import get from 'lodash/get';
import pick from 'lodash/pick';
import mapKeys from 'lodash/mapKeys';
import camelCase from 'lodash/camelCase';
import HtmlTableToJson from 'html-table-to-json';

export const transformObjectKeys = objectList =>
  objectList.map(obj => mapKeys(obj, (_, key) => camelCase(key)));

export const transformMarketView = objectList => {
  const utilityColumns = ['category', 'changeType'];
  const dataSample = objectList[0];
  const validKeys = Object.keys(dataSample)
    .map(x => x.trim())
    .filter(x => x.length > 1);

  const columns = validKeys.reduce((accumulator, next) => {
    const camelCased = camelCase(next);
    const columnProps = {
      displayName: next,
      visible: !utilityColumns.includes(camelCased),
      accessor: x => get(x, camelCased, ''),
    };
    accumulator.push(columnProps);
    return accumulator;
  }, []);

  const rows = objectList.reduce((accumulator, next) => {
    const rowProps = pick(next, validKeys);
    accumulator.push(rowProps);
    return accumulator;
  }, []);

  return {
    columns,
    rows: transformObjectKeys(rows),
  };
};

export const normalizePrice = list => {
  return list.map(item => {
    return {
      ...item,
      marketPrice: item.marketPrice.replace(/\D/g, ''),
    };
  });
};

export const getMarketData = queryResponse => {
  const marketContexts = [
    { name: 'marketView', tableIndex: 0, transform: transformMarketView },
    {
      name: 'marketIndices',
      tableIndex: 1,
      transform: val => normalizePrice(transformObjectKeys(val)),
    },
    {
      name: 'analyticalReports',
      tableIndex: 2,
      transform: transformObjectKeys,
    },
  ];
  const content = get(queryResponse, 'wordpressPage.content', '');
  const { results } = new HtmlTableToJson(content);

  return marketContexts.reduce(
    (accumulator, next) => ({
      ...accumulator,
      [next.name]: next.transform(get(results, `${next.tableIndex}`, [])),
    }),
    {}
  );
};
